import { Grid, Skeleton, Paper, Box } from "@mui/material";
import { memo, useEffect, useState } from "react";
import { getDashboardApi } from "../../apis/dashboard.api";
import { useDispatch } from "react-redux";
import { callApiAction } from "../../store/actions/commonAction";
import Counts from "../dashboard/Counts"; // 👈 reuse your Dashboard Counts box
import { HAS_HEARING_LOSS } from "../../utils/beneficiary.constant";

const BenificiaryCounts = ({ filters, setFilters }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const fetchCountFun = () => {
    setLoading(true);
    dispatch(
      callApiAction(
        async () => await getDashboardApi({ ...filters }),
        (response) => {
          setData(response);
          setLoading(false);
        },
        () => setLoading(false)
      )
    );
  };

  useEffect(() => {
    fetchCountFun();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters.startDate, filters.endDate, filters.state, filters.district, filters.taluka, filters.camp]);

  if (loading || !data)
    return (
      <Grid container spacing={2}>
        {[0, 1, 2].map((i) => (
          <Grid item xs={12} md={4} key={i}>
            <Paper component={Box} p={2}>
              <Skeleton variant="rounded" height="120px" width="100%" />
            </Paper>
          </Grid>
        ))}
      </Grid>
    );

  return (
    <Grid container spacing={2} mt={2} mb={3}>
  <Grid item xs={12} md={3}>
    <Box
      onClick={() => setFilters({ ...filters, hearingLoss: null })}
      sx={{ cursor: "pointer" }}
    >
      <Counts
        title="Total Beneficiaries"
        count={data.overall.total ?? 0}
        active={!filters.hearingLoss}   // ✅ highlight when no filter applied
      />
    </Box>
  </Grid>

  <Grid item xs={12} md={3}>
    <Box
      onClick={() => setFilters({ ...filters, hearingLoss: HAS_HEARING_LOSS.NO })}
      sx={{ cursor: "pointer" }}
    >
      <Counts
        title="Normal Hearing"
        count={data.overall.normal ?? 0}
        active={filters.hearingLoss === HAS_HEARING_LOSS.NO} // ✅ highlight active
      />
    </Box>
  </Grid>

  <Grid item xs={12} md={3}>
    <Box
      onClick={() => setFilters({ ...filters, hearingLoss: HAS_HEARING_LOSS.YES })}
      sx={{ cursor: "pointer" }}
    >
      <Counts
        title="Hearing Loss"
        count={data.overall.hearing_loss ?? 0}
        active={filters.hearingLoss === HAS_HEARING_LOSS.YES} // ✅ highlight active
      />
    </Box>
  </Grid>

    <Grid item xs={12} md={3}>
    <Box
      onClick={() => setFilters({ ...filters, hearingLoss: 3 })}
      sx={{ cursor: "pointer" }}
    >
      <Counts
        title="Pending"
        count={data.overall.not_tested ?? 0}
        active={filters.hearingLoss === 3} // ✅ highlight active
      />
    </Box>
  </Grid>
  
</Grid>

  );
};

export default memo(BenificiaryCounts);
